"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Routing = require("Functions/Routing");
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ShareProject = props => {
  const [shareWith, setShareWith] = (0, _react.useState)("");
  const [status, setStatus] = (0, _react.useState)("");
  const projectId = document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1];
  const sharedWith = props.sharedWith;
  const onSubmit = async e => {
    try {
      let response = await (0, _ajaxRequest.default)((0, _Routing.action)('updateProject'), {
        data: {
          shared_with: shareWith,
          id: projectId
        }
      });
      const {
        statement,
        error,
        info,
        warning
      } = response;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      props.handleCharedWith(response.data);
    } catch (update) {
      const {
        statement,
        error,
        info,
        warning
      } = update;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      return;
    }
  };
  const cancelShare = async () => {
    try {
      let response = await (0, _ajaxRequest.default)((0, _Routing.action)('updateProject'), {
        data: {
          unset: sharedWith,
          id: projectId
        }
      });
      const {
        statement,
        error,
        info,
        warning
      } = response;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      props.handleCharedWith(null);
    } catch (update) {
      const {
        statement,
        error,
        info,
        warning
      } = update;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      return;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "share-project c-paper"
  }, sharedWith ? /*#__PURE__*/_react.default.createElement("div", {
    className: "u-flex u-center"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Dossier partag\xE9 avec : ", sharedWith), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn--small--h20', ['primary']),
    onClick: cancelShare
  }, "Annuler le partage")) : /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 6,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Partager avec un orthodontiste:")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setShareWith(e.value),
    value: shareWith,
    name: "",
    type: "email",
    label: "E-mail de l'orthodontiste",
    status: {
      status
    }
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['primary']),
    onClick: onSubmit
  }, "Partager"))), (0, _getFormStatus.default)(status));
};
var _default = exports.default = ShareProject;
